import axios from "axios";
import {
  getBaseUrl,
  Microservice,
} from "@funded-here-interface/common/src/constant/baseUrl";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";
import {
  MRT_ColumnFiltersState,
  MRT_PaginationState,
  MRT_SortingState,
} from "mantine-react-table";

export interface TransactionsResponse {
  data: TransactionsData[];
  meta: {
    totalRowCount: number;
  };
}

export interface TransactionsData {
  skuId: string;
  merchantEmail: string;
  amount: string;
  currency: string;
  quantitySold: number;
  transactionId: string;
  transactionDate: string;
  createdAt: string;
}

interface TransactionsRequest {
  token: string;
  pagination: MRT_PaginationState;
  columnFilters: MRT_ColumnFiltersState;
  sorting: MRT_SortingState;
}

const getTransactionsData = async ({
  token,
  pagination,
  columnFilters,
  sorting,
}: TransactionsRequest): Promise<TransactionsResponse> => {
  try {
    const response = await axios.get(
      `${getBaseUrl(Microservice.OMS)}/oms/transaction/get-transaction-data`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        params: {
          page: `${pagination.pageIndex + 1}`,
          pageSize: `${pagination.pageSize}`,
          columnFilters,
          sorting: sorting,
        },
        withCredentials: true,
      },
    );

    return response.data;
  } catch (error) {
    const message = getApiResponseErrorMsg(error);

    throw new Error(message);
  }
};

export default getTransactionsData;
